var React = require('react');

function Account (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.1958 20.9172C17.9584 20.9172 19.1629 19.2249 18.5 17.6778C17.1429 14.5027 13.8481 12.2613 9.99976 12.2613C6.15138 12.2613 2.85811 14.5012 1.49951 17.6778C0.836667 19.2264 2.04116 20.9172 3.80375 20.9172H16.1958Z","stroke":"#2D2927","strokeWidth":"1.59601","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M9.99986 9.6788C12.398 9.6788 14.342 7.73476 14.342 5.33666C14.342 2.93856 12.398 0.994514 9.99986 0.994514C7.60176 0.994514 5.65771 2.93856 5.65771 5.33666C5.65771 7.73476 7.60176 9.6788 9.99986 9.6788Z","stroke":"#2D2927","strokeWidth":"1.59601","strokeMiterlimit":"10","key":1})]);
}

Account.defaultProps = {"width":"20","height":"22","viewBox":"0 0 20 22","fill":"none"};

module.exports = Account;

Account.default = Account;
